export default __webpack_public_path__ + "static/media/github-logo.6c28563b.png";